import React, { createRef, ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import queryString from 'query-string';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ReactGA from 'react-ga';

import MainLayout, {
  media,
  SearchContent,
  SearchPanel,
} from '../../common/Layout';
import RelatedSearch from './RelatedSearch';
import SearchList from './itemList/SearchList';
import ImageList from './itemList/ImageList';

import SkeletonCard from '../common/SkeletonCard';

import KnowledgeGraph from './KnowledgeGraph';
import PopularKeyword from './PopularKeyword';

import ViewMore from '../viewMore';

import IconArrow from '../../../assets/icon/3-10@2x.png';

import {
  GetSearchParamType,
  GetPopularKeywordParamType,
} from '../../../lib/tabResult/type';
import { tabResultState } from '../../../modules/tabResult';
import { searchKeywordState } from '../../../modules/searchKeyword';
import {
  MoreViewBoxResult,
  MoreViewInnerBoxResult,
  MoreViewArrowResult,
  MoreViewTitleResult,
  NoDataTitle,
} from '../common/Layout';
import { PostConsumptionBodyType } from '../../../lib/common/type';
import { ReactNodeArray } from 'prop-types';

interface styleType {
  isFixKeyword?: boolean;
}

const ResultComponent = styled(MainLayout)``;

const ResultCountBox = styled.div`
  display: flex;
  flex: 1 0 auto;
  height: 24px;
  margin-top: 32px;

  width: 100%;
  ${(props: styleType) => {
    if (props.isFixKeyword) {
      return css`
        margin-top: 0px;
      `;
    }
    return css``;
  }}
  /* Mobile Device */
    margin-bottom: 6px;

  ${media.desktop`  
    margin-bottom: 18px;
  `};
`;
const ResultCountTitle = styled.div`
  display: flex;
  height: 24px;
  font-size: 16px;
  font-weight: 500;
`;
const ResultCountValue = styled.div`
  display: flex;
  height: 24px;
  font-size: 16px;
  font-weight: normal;
  color: #666666;
  margin-left: 7px;
`;

const MobileRelatedSearch = styled.div`
  /* Mobile Device */
  display: flex;

  ${media.desktop`  
    display: none;
  `};
`;

const DesktopRelatedSearch = styled.div`
  /* Mobile Device */
  display: none;

  ${media.desktop`  
    display: flex;
  `};
`;

const NoDataBox = styled.div`
  margin-top: 44px;
`;

const NoDataSuggestTitle = styled.div`
  font-family: 'NotoKrM';
  font-size: 14px;
  color: #222222;
  margin-bottom: 6px;
  margin-top: 20px;
`;

const NoDataListBox = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
`;
const NoDataSuggestDot = styled.div`
  display: flex;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  margin-right: 6px;
  background-color: #222222;
`;
const NoDataSuggestList = styled.div`
  display: flex;
  font-family: 'NotoKrL';
  font-size: 14px;
  color: #222222;
`;
const FixKeyword = styled.span`
  font-family: 'NotoKrL';
  font-size: 18px;
  margin-right: 10px;
  color: #222222;
  /* margin-top: 6px; */
  ${(props: styleType) => {
    if (props.isFixKeyword) {
      return css`
        font-size: 14px;
      `;
    }
    return css``;
  }}
`;
const FixKeywordList = styled.div`
  display: flex;
`;
const FixKeywordLink = styled.div`
  font-family: 'NotoKrM';
  font-size: 17px;
  margin-right: 10px;
  color: #0355aa;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  ${(props: styleType) => {
    if (props.isFixKeyword) {
      return css`
        font-size: 14px;
      `;
    }
    return css``;
  }}
`;
const FixKeywordSmall = styled.div`
  display: flex;
  flex: 1 0 auto;
  width: 100%;

  /* Mobile Device */
  flex-direction: column;
  margin-top: 22px;
  margin-bottom: 6px;

  ${media.desktop`  
    flex-direction: row;
    margin-top: 32px;
    margin-bottom: 10px;
  `};
`;

function isString(val: string | string[]): val is string {
  return typeof val === 'string';
}

interface ResultProps extends RouteComponentProps {
  onSetMenuID: (selectedMenuId: number) => void;
  onGetSearch: (info: GetSearchParamType) => void;
  onGetPopularKeyword: (info: GetPopularKeywordParamType) => void;

  onSetIsMoreInfoResult: (
    isMoreInfoResult: tabResultState['isMoreInfoResult']
  ) => void;
  onSetIsMoreInfoAttachment: (
    isMoreInfoAttach: tabResultState['isMoreInfoAttach']
  ) => void;
  onSetIsMoreInfoImage: (
    isMoreInfoImage: tabResultState['isMoreInfoImage']
  ) => void;
  onSetSearchKeyword: (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => void;
  onPostConsumption: (info: PostConsumptionBodyType) => void;

  travel_info: tabResultState['travel_info'];
  recommended_info: tabResultState['recommended_info'];
  course_info: tabResultState['course_info'];
  imageResult: tabResultState['imageResult'];
  attachResult: tabResultState['attachResult'];
  relatedWord: tabResultState['relatedWord'];
  popularKeyword: tabResultState['popularKeyword'];
  wikiData: tabResultState['wikiData'];
  isMoreInfoImage: tabResultState['isMoreInfoImage'];
  isMoreInfoAttach: tabResultState['isMoreInfoAttach'];
  isMoreInfoResult: tabResultState['isMoreInfoResult'];
  spellCheckerData: tabResultState['spellCheckerData'];
  loading: boolean;
}

interface ResultState {
  targetId: number;
  isResultRender: boolean;

}

interface GetSpellCheckType {
  status_code: number;
  message: string;
  payload: string[] | boolean;
}

class Result extends React.Component<ResultProps, ResultState> {
  private listRef: any = null;
  state = {
    targetId: 0,
    isResultRender: false,

  };

  componentDidMount() {
    ReactGA.ga('send', 'event', `view_search_result_tab`);
  }

  MoreInfoClickResult = (targetId: number) => {
    const { onSetIsMoreInfoResult } = this.props;
    this.setState({
      targetId,
    });

    onSetIsMoreInfoResult(true);
  };

  MoreInfoClickAttach = () => {
    const { onSetIsMoreInfoAttachment } = this.props;
    onSetIsMoreInfoAttachment(true);
  };

  MoreInfoClickImage = () => {
    const { location, history } = this.props;

    const query = queryString.parse(location.search);
    let keyword: string | string[] = '';
    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
    }
    history.push(`/search/image?q=${keyword}`);
    window.location.reload();
  };

  makeSpellCheckList = (isFixKeyword: boolean): ReactNode[] | null => {
    const { history } = this.props;
    const result: ReactNode[] | null = [];
    const listResult: ReactNode[] | null = [];
    const { spellCheckerData } = this.props;

    if (Array.isArray(spellCheckerData)) {
      result.push(
        <FixKeyword isFixKeyword={isFixKeyword}>
          다음은 수정된 검색어 입니다.
        </FixKeyword>
      );
      spellCheckerData.forEach((element) => {
        listResult.push(
          <FixKeywordLink
            isFixKeyword={isFixKeyword}
            onClick={() => {
              ReactGA.ga('send', 'event', `click_search_수정된검색어`);
              history.push(`/search/result?q=${element}`);
              window.location.reload();
            }}
          >
            {element}
          </FixKeywordLink>
        );
      });
      result.push(<FixKeywordList>{listResult}</FixKeywordList>);
    } else {
      result.push(null);
    }

    return result;
  };

  makeNodataList = (): ReactNode[] | null => {
    const { loading, location } = this.props;

    const query = queryString.parse(location.search);
    let keyword: string | string[] = '';
    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
    }

    const result: ReactNode[] | null = [];
    if (loading) {
      result.push(<SkeletonCard />);
    } else {
      result.push(
        <NoDataBox>
          <NoDataTitle>
            <em>&#39;{keyword}&#39;</em>
            <div>와(과) 일치되는 정보가 없습니다.</div>
          </NoDataTitle>
          {this.makeSpellCheckList(false)}
          <NoDataSuggestTitle>제안</NoDataSuggestTitle>
          <NoDataListBox>
            <NoDataSuggestDot />
            <NoDataSuggestList>
              모든 단어의 철자가 정확한지 확인하세요.
            </NoDataSuggestList>
          </NoDataListBox>
          <NoDataListBox>
            <NoDataSuggestDot />
            <NoDataSuggestList>다른 검색어를 사용해 보세요.</NoDataSuggestList>
          </NoDataListBox>
          <NoDataListBox>
            <NoDataSuggestDot />
            <NoDataSuggestList>
              더 일반적인 검색어를 사용해 보세요.
            </NoDataSuggestList>
          </NoDataListBox>
        </NoDataBox>
      );
    }
    return result;
  };

  makeKeywordCount = (targetId: number): ReactNode[] | null => {
    const {
      travel_info,
      course_info,
      recommended_info,
      attachResult,
      location,
      spellCheckerData,
    } = this.props;

    const query = queryString.parse(location.search);
    let keyword: string | string[] = '';
    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
    }

    const result: ReactNode[] | null = [];
    let isFixKeyword = false;

    if (Array.isArray(spellCheckerData)) {
      isFixKeyword = true;
    } else {
      isFixKeyword = false;
    }

    switch (targetId) {
      case 0:
        result.push(
          <ResultCountBox isFixKeyword={isFixKeyword}>
            <ResultCountTitle>&apos;{keyword}&apos;</ResultCountTitle>
            <ResultCountValue>
              여행지 검색결과 {travel_info?.total || 0}개
            </ResultCountValue>
          </ResultCountBox>
        );
        break;
      case 1:
        if (isFixKeyword || (travel_info && travel_info.total > 0)) {
          isFixKeyword = false;
        }
        result.push(
          <ResultCountBox isFixKeyword={isFixKeyword}>
            <ResultCountTitle>&apos;{keyword}&apos;</ResultCountTitle>
            <ResultCountValue>
              추천 관광지 검색결과 {recommended_info?.total || 0}개
            </ResultCountValue>
          </ResultCountBox>
        );
        break;
      case 2:
        if (
          isFixKeyword ||
          (travel_info && travel_info.total > 0) ||
          (recommended_info && recommended_info.total > 0)
        ) {
          isFixKeyword = false;
        }
        result.push(
          <ResultCountBox isFixKeyword={isFixKeyword}>
            <ResultCountTitle>&apos;{keyword}&apos;</ResultCountTitle>
            <ResultCountValue>
              관광지 코스 검색결과 {course_info?.total || 0}개
            </ResultCountValue>
          </ResultCountBox>
        );
        break;
      case 3:
        if (
          isFixKeyword ||
          (travel_info && travel_info.total > 0) ||
          (recommended_info && recommended_info.total > 0) ||
          (course_info && course_info.total > 0)
        ) {
          isFixKeyword = false;
        }
        result.push(
          <ResultCountBox isFixKeyword={isFixKeyword}>
            <ResultCountTitle>&apos;{keyword}&apos;</ResultCountTitle>
            <ResultCountValue>
              첨부파일 검색결과 {attachResult?.total || 0}개
            </ResultCountValue>
          </ResultCountBox>
        );
        break;
      default:
        break;
    }

    return result;
  };

  makeSpellCheckListOnSearch = (): ReactNode[] | null => {
    const { spellCheckerData } = this.props;
    const result: ReactNode[] | null = [];
    if (Array.isArray(spellCheckerData)) {
      result.push(
        <FixKeywordSmall>{this.makeSpellCheckList(true)}</FixKeywordSmall>
      );
    }

    return result;
  };

  printattachList = () => {
    const {
      relatedWord,
      popularKeyword,
      travel_info,
      recommended_info,
      course_info,
      imageResult,
      attachResult,

      onGetPopularKeyword,
      onSetSearchKeyword,

      wikiData,
      onGetSearch,
      onSetIsMoreInfoResult,
      onSetIsMoreInfoAttachment,
      onPostConsumption,
      isMoreInfoResult,
      isMoreInfoAttach,
      loading,
    } = this.props;


    if (!loading && attachResult && attachResult.total > 0) {
      const result = (
        <>
          {this.makeKeywordCount(3)}
          <SearchList
            limitList={5}
            attachResult={attachResult}
            onPostConsumption={onPostConsumption}
          />
          <MoreViewBoxResult>
            <MoreViewInnerBoxResult
              onClick={() => {
                ReactGA.ga(
                  'send',
                  'event',
                  `click_search_result_normal_view_more_button`
                );
                this.MoreInfoClickResult(3);

              }}
            >
              <MoreViewArrowResult src={IconArrow} alt="more view" />
              <MoreViewTitleResult>검색결과 더보기</MoreViewTitleResult>
            </MoreViewInnerBoxResult>
          </MoreViewBoxResult>
        </>
      )
      if (this.listRef) {
        return result;
      }
      if (travel_info?.total === 0 && recommended_info?.total === 0 && course_info?.total === 0) {
        return result;
      }
    }
    return null
  }



  render() {
    const {
      relatedWord,
      popularKeyword,
      travel_info,
      recommended_info,
      course_info,
      imageResult,
      attachResult,

      onGetPopularKeyword,
      onSetSearchKeyword,

      wikiData,
      onGetSearch,
      onSetIsMoreInfoResult,
      onSetIsMoreInfoAttachment,
      onPostConsumption,
      isMoreInfoResult,
      isMoreInfoAttach,
      loading,
    } = this.props;
    const { targetId } = this.state;

    return (
      <ResultComponent>
        <SearchContent>
          {isMoreInfoResult ? (
            <ViewMore
              travel_info={travel_info}
              recommended_info={recommended_info}
              attachResult={attachResult}
              course_info={course_info}
              targetId={targetId}
              isContents={isMoreInfoResult}
              loading={loading}
              onGetSearch={onGetSearch}
              onSetIsMoreInfoResult={onSetIsMoreInfoResult}
              onPostConsumption={onPostConsumption}
            />
          ) : (
            <>
              <DesktopRelatedSearch>
                {relatedWord.length > 0 ? (
                  <RelatedSearch relatedWord={relatedWord} />
                ) : null}
              </DesktopRelatedSearch>

              {(travel_info && travel_info.total > 0) ||
                (recommended_info && recommended_info.total > 0) ||
                (course_info && course_info.total > 0) ||
                (attachResult && attachResult.total > 0)
                ? this.makeSpellCheckListOnSearch()
                : this.makeNodataList()}

              {!loading && travel_info && travel_info.total > 0 ? (
                <>
                  {this.makeKeywordCount(0)}
                  <SearchList
                    ref={(ref) => {
                      this.listRef = ref;
                    }}
                    limitList={5}
                    travel_info={travel_info}
                    onPostConsumption={onPostConsumption}
                  />
                  <MoreViewBoxResult>
                    <MoreViewInnerBoxResult
                      onClick={() => {
                        ReactGA.ga(
                          'send',
                          'event',
                          `click_search_result_normal_view_more_button`
                        );
                        this.MoreInfoClickResult(0);
                      }}
                    >
                      <MoreViewArrowResult src={IconArrow} alt="more view" />
                      <MoreViewTitleResult>검색결과 더보기</MoreViewTitleResult>
                    </MoreViewInnerBoxResult>
                  </MoreViewBoxResult>

                </>
              ) : null}

              {!loading && recommended_info && recommended_info.total > 0 ? (
                <>
                  {this.makeKeywordCount(1)}
                  <SearchList

                    ref={(ref) => {
                      this.listRef = ref;
                    }}
                    limitList={5}
                    recommended_info={recommended_info}
                    onPostConsumption={onPostConsumption}
                  />
                  <MoreViewBoxResult>
                    <MoreViewInnerBoxResult
                      onClick={() => {
                        ReactGA.ga(
                          'send',
                          'event',
                          `click_search_result_normal_view_more_button`
                        );
                        this.MoreInfoClickResult(1);
                      }}
                    >
                      <MoreViewArrowResult src={IconArrow} alt="more view" />
                      <MoreViewTitleResult>검색결과 더보기</MoreViewTitleResult>
                    </MoreViewInnerBoxResult>
                  </MoreViewBoxResult>
                </>
              ) : null}

              {!loading && course_info && course_info.total > 0 ? (
                <>
                  {this.makeKeywordCount(2)}
                  <SearchList
                    ref={(ref) => {
                      this.listRef = ref;
                    }}
                    limitList={5}
                    course_info={course_info}
                    onPostConsumption={onPostConsumption}
                  />
                  <MoreViewBoxResult>
                    <MoreViewInnerBoxResult
                      onClick={() => {
                        ReactGA.ga(
                          'send',
                          'event',
                          `click_search_result_normal_view_more_button`
                        );
                        this.MoreInfoClickResult(2);
                      }}
                    >
                      <MoreViewArrowResult src={IconArrow} alt="more view" />
                      <MoreViewTitleResult>검색결과 더보기</MoreViewTitleResult>
                    </MoreViewInnerBoxResult>
                  </MoreViewBoxResult>
                </>
              ) : null}

              {/* {this.printattachList()} */}

              {!loading && attachResult && attachResult.total > 0 ? (
                <>
                  {this.makeKeywordCount(3)}
                  <SearchList
                    limitList={5}
                    attachResult={attachResult}
                    onPostConsumption={onPostConsumption}
                  />
                  <MoreViewBoxResult>
                    <MoreViewInnerBoxResult
                      onClick={() => {
                        ReactGA.ga(
                          'send',
                          'event',
                          `click_search_result_normal_view_more_button`
                        );
                        this.MoreInfoClickResult(3);

                      }}
                    >
                      <MoreViewArrowResult src={IconArrow} alt="more view" />
                      <MoreViewTitleResult>검색결과 더보기</MoreViewTitleResult>
                    </MoreViewInnerBoxResult>
                  </MoreViewBoxResult>
                </>
              ) : null}

              {/* {imageResult && imageResult.results.length > 0 ? (
                <>
                  <ImageList
                    imageResult={imageResult}
                    onPostConsumption={onPostConsumption}
                  />
                  <MoreViewBoxResult>
                    <MoreViewInnerBoxResult
                      onClick={() => {
                        ReactGA.ga(
                          'send',
                          'event',
                          `click_search_result_image_view_more_button`
                        );
                        this.MoreInfoClickImage();
                      }}
                    >
                      <MoreViewArrowResult src={IconArrow} alt="more view" />
                      <MoreViewTitleResult>이미지 더보기</MoreViewTitleResult>
                    </MoreViewInnerBoxResult>
                  </MoreViewBoxResult>
                </>
              ) : null} */}
              {/* {recommended_info ? (
                <>
                  <AttachmentList recommended_info={recommended_info} />
                  <MoreViewBoxResult>
                    <MoreViewInnerBoxResult
                      onClick={() => {
                        ReactGA.ga(
                          'send',
                          'event',
                          `click_search_result_attachment_view_more_button`
                        );
                        this.MoreInfoClickAttach();
                      }}
                    >
                      <MoreViewArrowResult src={IconArrow} alt="more view" />
                      <MoreViewTitleResult>첨부파일 더보기</MoreViewTitleResult>
                    </MoreViewInnerBoxResult>
                  </MoreViewBoxResult>
                </>
              ) : null} */}
            </>
          )}
        </SearchContent>

        <SearchPanel>
          {imageResult && imageResult.results.length > 0 ? (
            <>
              <ImageList
                imageResult={imageResult}
                onPostConsumption={onPostConsumption}
              />
              <MoreViewBoxResult>
                <MoreViewInnerBoxResult
                  onClick={() => {
                    ReactGA.ga(
                      'send',
                      'event',
                      `click_search_result_image_view_more_button`
                    );
                    this.MoreInfoClickImage();
                  }}
                >
                  <MoreViewArrowResult src={IconArrow} alt="more view" />
                  <MoreViewTitleResult>이미지 더보기</MoreViewTitleResult>
                </MoreViewInnerBoxResult>
              </MoreViewBoxResult>
            </>
          ) : null}
          {wikiData ? <KnowledgeGraph wikiData={wikiData} /> : null}
          <MobileRelatedSearch>
            {relatedWord.length > 0 ? (
              <RelatedSearch relatedWord={relatedWord} />
            ) : null}
          </MobileRelatedSearch>
          {popularKeyword.length > 0 ? (
            <PopularKeyword
              popularKeyword={popularKeyword}
              onGetPopularKeyword={onGetPopularKeyword}
              onSetSearchKeyword={onSetSearchKeyword}
            />
          ) : null}
        </SearchPanel>
      </ResultComponent>
    );
  }
}

export default withRouter(Result);
